import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { useAppDispatch } from 'hooks';

// project imports
import { setMenu } from 'store/menuReducer';

// ==============================|| SIDEBAR MENU LIST ITEM ||============================== //

const NavItem = ({ item, level }) => {
    const dispatch = useAppDispatch();
    const { pathname } = useLocation();

    const isActive = item.url === pathname || (item.url !== '/' && pathname.startsWith(`${item.url}/`));

    const Icon = item.icon;
    const className = `gd-nav-item${isActive ? ' gd-nav-item--active' : ''}`;
    const style = level > 1 ? { paddingLeft: `${level * 16}px` } : undefined;

    const content = (
        <>
            {Icon && <Icon stroke={1.5} size={20} />}
            <span>{item.title}</span>
        </>
    );

    const handleClick = () => {
        // Close the drawer on small screens after navigating.
        if (typeof window !== 'undefined' && window.matchMedia('(max-width: 900px)').matches) {
            dispatch(setMenu(false));
        }
    };

    if (item.external) {
        return (
            <a className={className} style={style} href={item.url} target={item.target ? '_blank' : '_self'} rel="noreferrer">
                {content}
            </a>
        );
    }

    return (
        <Link className={className} style={style} to={item.url} target={item.target ? '_blank' : '_self'} onClick={handleClick}>
            {content}
        </Link>
    );
};

NavItem.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

export default NavItem;
